import { Navigate, useRoutes } from 'react-router-dom';

import EmptyLayout from 'layout/empty';
import MaterialLayout from 'layout/material';

import { route as homeRoute } from 'modules/home/route';
import { route as signInRoute } from 'modules/sign-in/route';
import { route as recognitionRoute } from 'modules/recognition/route';
import { route as enrollmentRoute } from 'modules/enrollment/route';
import { route as idemiaRoute } from 'modules/Idemia/route';

const Router = () => {
  return useRoutes([
    {
      path: '/',
      element: <EmptyLayout />,
      children: [
        homeRoute,
        signInRoute,
      ],
    },
    {
      path: '/public',
      element: <MaterialLayout />,
      children: [
        recognitionRoute,
        enrollmentRoute,
        ...idemiaRoute,
      ],
    },
    { path: "*", element: <Navigate to="/" /> },
  ]);
};

export default Router;
